import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        divider: {my: 'medium.base', color: 'background.light'},
        downloadIcon: {height: remCalc(40), width: remCalc(40)},
        dropdownContainer: {width: '100%', maxWidth: remCalc(351)},
        pageContainer: {flexDirection: 'column', w: '100%'},
        headingSection: {
            background: 'background.light',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: {base: 'center', lg: 'left'},
            paddingY: {base: 'medium.base', lg: 'medium.lg'},
            paddingX: 'small.base',
            gap: 'medium.base',
        },
        headingTitle: {
            textStyle: 'head-medium',
            fontWeight: '500',
            color: 'text.default',
        },
        headingSubtitle: {
            textStyle: 'body-large',
            fontWeight: '400',
            color: 'text.default',
        },
        imageContainer: {
            width: '100%',
            maxW: {base: remCalc(133), lg: remCalc(332)},
        },
        productSection: {
            width: '100%',
            layerStyle: 'full-width',
            margin: {base: `${remCalc(40)} auto`, lg: `${remCalc(80)} auto`},
            flexDirection: {base: 'column', lg: 'row'},
            paddingX: {base: 'small.base', lg: 'small.lg', xl: 'unset'},
            justifyContent: 'space-between',
            gap: {base: 'medium.md', lg: 'medium.base'},
        },
        productInfo: {
            flexDirection: {base: 'row', lg: 'column'},
            gap: {base: 'xsmall.sm', lg: 'medium.base'},
            justifyContent: {base: 'center', lg: 'unset'},
            alignItems: 'center',
        },
        productDetails: {
            flexDirection: 'column',
            gap: 'xsmall.sm',
            textAlign: 'center',
            justifyContent: {base: 'center', lg: 'unset'},
        },
        productDetailsTitle: {textStyle: 'head-medium', fontWeight: '500', color: 'text.default'},
        productDetailsId: {textStyle: 'body-medium', fontWeight: '400', color: 'text.secondary'},
        productManualsContainer: {flexDirection: 'column', gap: remCalc(10)},
        productManualsHeader: {
            flexDirection: {base: 'column', lg: 'row'},
            gap: {base: 'small.base', lg: 'unset'},
            justifyContent: {base: 'center', lg: 'space-between'},
            marginBottom: {base: 'large.base', lg: 'large.lg'},
            alignItems: 'center',
        },
        productManualsSection: {flexDirection: 'column', width: '100%'},
        productManualCard: {justifyContent: 'space-between'},
        fileLabel: {textStyle: 'body-large', fontWeight: '400', color: 'text.default'},
        filesizeText: {textStyle: 'body-small', fontWeight: '400', color: 'text.secondary'},
        fileFlex: {
            alignItems: 'center',
        },
    },
    variants: {
        plpManuals: {
            divider: {my: remCalc(10)},
            fileLabel: {textStyle: 'body-medium', fontWeight: '400', color: 'text.default'},
            fileFlex: {
                flexDirection: 'column',
            },
        },
    },
}
